import { cell_t, project_t } from '../logic/types';
import { instance as axios } from './config';

export const api = {
   
    getTranslations(lang: string, type: 'modalTranslation' | 'pageTranslation') {
        return axios.post('translations', {
            lang,
            type,
        });
    },
    getAvailableLangList() {
        return axios.get('translations/getAllTranslations');
    },
    saveLanguages(lang: string, type: 'modalTranslation' | 'pageTranslation', translation: any) {
        return axios.post('translations/create', {
            translations: { lang, type, translation },
        });
    },

    fetchProjects() {
        return axios.get('projects');
    },

    saveProject(project: any) {
        return axios.post('projects/update', { project });
    },

    deleteProject(id: string) {
        return axios.post('projects/delete', { id: id });
    },
    fetchProjectsCells(project_id: string) {
        return axios.post('cells', { project_id });
    },
    saveCell(project_id: string, cell: cell_t) {
        return axios.post('cells/update', { cell: {project_id:project_id,  ...cell } });
    },

    deleteCell(project_id: string, cell_id: string) {
        return axios.post('cells/delete', { project_id, cell_id });
    },
};
